<div class="circular-progress-bar" [style.width.px]="size" [style.height.px]="size">
  <svg [attr.width]="size" [attr.height]="size" class="progress-ring">
    <!-- Background circle -->
    <circle
      class="progress-ring__circle-bg"
      [attr.stroke-width]="strokeWidth"
      fill="transparent"
      [attr.r]="radius"
      [attr.cx]="size / 2"
      [attr.cy]="size / 2"
    />
    <!-- Progress circle -->
    <circle
      class="progress-ring__circle"
      [attr.stroke]="color"
      [attr.stroke-width]="strokeWidth"
      fill="transparent"
      [attr.r]="radius"
      [attr.cx]="size / 2"
      [attr.cy]="size / 2"
      [style.stroke-dasharray]="circumference + ' ' + circumference"
      [style.stroke-dashoffset]="strokeDashoffset"
    />
  </svg>
  <!-- Percentage text overlay -->
  <div class="progress-text" *ngIf="showPercentageText">
    <span class="percentage-value">{{ percentage }}</span>
    <span class="percentage-symbol">%</span>
  </div>
</div>

